<template>
	<div class="p4">
		<transaction-create-update-form @submit="handleSubmit">
			<div class="xs-12 flex xs-between mt6" slot-scope="{ onSubmit }">
				<!-- This button is using scoped slot method onSubmit that actually emits @submit event -->
				<j-button @click="onSubmit" :isLoading="isLoading">
					{{ $t("save") }}
				</j-button>
				<j-button
					@click="$emit('cancel')"
					:isDisabled="isLoading"
					type="bordered"
				>
					{{ $t("cancel") }}
				</j-button>
			</div>
		</transaction-create-update-form>
	</div>
</template>

<script>
import TransactionCreateUpdateForm from "./TransactionCreateUpdateForm"
import JButton from "@/components/JButton"
import api from "../api"
import { transformDateTime } from "@/utils/"

export default {
	components: { TransactionCreateUpdateForm, JButton },
	props: {
		claimId: {
			type: String,
			required: true,
			default: ""
		}
	},
	data() {
		return {
			isLoading: false
		}
	},
	methods: {
		async handleSubmit(payload) {
			if (!this.claimId) return

			this.isLoading = true
			const res = await api.addTransaction({
				input: {
					...payload,
					claimId: this.claimId,
					dateTime: transformDateTime(payload.dateTime)
				}
			})
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// If all good emit event
			this.$emit("transaction:added")
		}
	}
}
</script>
